import React from 'react';

export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50 overflow-y-auto">
      <button
        onClick={onClose}
        className="absolute inset-0 w-full h-full cursor-default"
        aria-label="Close modal"
        type="button"
      />
      <div className="relative w-full max-w-5xl z-10">
        <div className="sp-panel">
          {children}
        </div>
      </div>
    </div>
  );
}
